// @ts-nocheck
import { APPRADIO_ORIGIN } from "./origins";
function rpOnReady(fn) {
    if (typeof fn !== 'function') return;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
}

export function initRadioDetailPage() {
/* ---- radio.php inline script 1 ---- */
(function() {
    var L = window.radioPageI18n || {};
    var openBtn   = document.getElementById('radio-report-open-btn');
    var modal     = document.getElementById('radio-report-modal');
    var backdrop  = modal ? modal.querySelector('.radio-report-modal-backdrop') : null;
    var cancelBtn = modal ? document.getElementById('radio-report-cancel-btn') : null;
    var form      = modal ? document.getElementById('radio-report-form') : null;
    var descInput = modal ? document.getElementById('radio-report-description') : null;
    var submitBtn = modal ? document.getElementById('radio-report-submit-btn') : null;

    if (!openBtn || !modal || openBtn.dataset.rpBound === '1') return;
    openBtn.dataset.rpBound = '1';

    function showReportToast(message, type) {
        type = type || 'info';
        var toast = document.createElement('div');
        toast.className = 'radio-report-toast radio-report-toast-' + type;
        toast.textContent = message;
        toast.style.cssText =
            'position:fixed;bottom:20px;left:50%;transform:translateX(-50%);' +
            'padding:10px 18px;border-radius:999px;font-size:13px;' +
            'color:#fff;background:' + (type === 'success' ? '#16a34a' : type === 'error' ? '#dc2626' : '#4b5563') + ';' +
            'box-shadow:0 4px 12px rgba(0,0,0,0.25);z-index:9999;opacity:0;transition:opacity .2s ease';
        document.body.appendChild(toast);
        requestAnimationFrame(function () { toast.style.opacity = '1'; });
        setTimeout(function () {
            toast.style.opacity = '0';
            setTimeout(function () { toast.remove(); }, 200);
        }, 2600);
    }

    function openModal() {
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('radio-report-modal-open');
        if (descInput) {
            setTimeout(function() { descInput.focus(); }, 80);
        }
    }

    function closeModal() {
        // Se o foco ainda está dentro do modal, devolve para o botão de abrir
        if (document.activeElement && modal.contains(document.activeElement) && openBtn) {
            openBtn.focus();
        }
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('radio-report-modal-open');
        if (form) {
            form.reset();
        }
        if (submitBtn) {
            submitBtn.disabled = true;
        }
    }

    openBtn.addEventListener('click', function() {
        openModal();
    });

    if (backdrop) {
        backdrop.addEventListener('click', function() {
            closeModal();
        });
    }

    if (cancelBtn) {
        cancelBtn.addEventListener('click', function() {
            closeModal();
        });
    }

    if (form) {
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            if (!descInput || !submitBtn) {
                closeModal();
                return;
            }

            var description = descInput.value.trim();
            var emailInput  = document.getElementById('radio-report-email');
            var email       = emailInput ? emailInput.value.trim() : '';
            var radioId     = (window.__RADIOPRO_PAGE__ && window.__RADIOPRO_PAGE__.id)
                || parseInt((document.getElementById('radio-global-player') || document.querySelector('[data-radio-id]') || {}).getAttribute?.('data-radio-id') || '0', 10)
                || 0;

            if (!description) {
                return;
            }

            var originalLabel = submitBtn.getAttribute('data-original-label') || submitBtn.textContent;
            submitBtn.setAttribute('data-original-label', originalLabel);
            submitBtn.textContent = L.reportSubmitSending || '…';
            submitBtn.disabled = true;

            var formData = new FormData();
            formData.append('station_id', radioId);
            formData.append('description', description);
            if (email) {
                formData.append('email', email);
            }

            fetch('/ajax/ajax-report-error.php', {
                method: 'POST',
                body: formData
            })
                .then(function(resp) { return resp.json(); })
                .then(function(data) {
                    if (data && data.success) {
                        showReportToast(L.reportSuccess || '', 'success');
                    } else {
                        showReportToast(L.reportErrorSend || '', 'error');
                    }
                })
                .catch(function(err) {
                    console.error('Erro ao enviar relatório de rádio:', err);
                    showReportToast(L.reportErrorNetwork || '', 'error');
                })
                .finally(function() {
                    submitBtn.textContent = submitBtn.getAttribute('data-original-label') || L.reportSubmit || '';
                    submitBtn.disabled = true;
                    closeModal();
                });
        });
    }

    if (descInput && submitBtn) {
        descInput.addEventListener('input', function() {
            var hasText = this.value && this.value.trim().length > 0;
            submitBtn.disabled = !hasText;
        });
    }

    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) {
            closeModal();
        }
    });
})();

/* ---- radio.php inline script 2 ---- */
(function() {
    var L = window.radioPageI18n || {};
    var section = document.querySelector('.radio-detail-actions');
    if (!section || section.dataset.rpBound === '1') return;
    section.dataset.rpBound = '1';

    var INTENT_KEY = 'rpro_radio_station_action_intent_v1';
    var deleteBtn = document.getElementById('radio-action-delete-btn');
    var controlBtn = document.getElementById('radio-action-control-btn');
    var deleteModal = document.getElementById('radio-delete-request-modal');
    var controlModal = document.getElementById('radio-control-request-modal');
    var openModalRef = null;
    var lastTrigger = null;

    function getCookie(name) {
        var parts = document.cookie ? document.cookie.split(';') : [];
        for (var i = 0; i < parts.length; i++) {
            var part = parts[i].trim();
            if (part.indexOf(name + '=') === 0) {
                return decodeURIComponent(part.substring(name.length + 1));
            }
        }
        return '';
    }

    function isLoggedIn() {
        if (section.getAttribute('data-user-logged-in') === '1') return true;
        return getCookie('RPRO_USER_UID') !== '';
    }

    function stationReturnPath() {
        return section.getAttribute('data-station-return-path') || window.location.pathname;
    }

    function persistIntent(action) {
        if (!window.sessionStorage) return;
        try {
            sessionStorage.setItem(INTENT_KEY, JSON.stringify({
                action: action,
                stationId: section.getAttribute('data-station-id') || '',
                savedAt: Date.now()
            }));
        } catch (err) {}
    }

    function readIntent() {
        var params = new URLSearchParams(window.location.search);
        var fromQuery = params.get('rpro_action');
        if (fromQuery === 'delete_station' || fromQuery === 'request_control') {
            return fromQuery;
        }
        if (!window.sessionStorage) return '';
        try {
            var raw = sessionStorage.getItem(INTENT_KEY);
            if (!raw) return '';
            var parsed = JSON.parse(raw);
            return parsed && parsed.action ? String(parsed.action) : '';
        } catch (err) {
            return '';
        }
    }

    function clearIntent() {
        if (!window.sessionStorage) return;
        try { sessionStorage.removeItem(INTENT_KEY); } catch (err) {}
        var params = new URLSearchParams(window.location.search);
        if (!params.has('rpro_action')) return;
        params.delete('rpro_action');
        var next = window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash;
        window.history.replaceState({}, '', next);
    }

    function redirectToSso(action) {
        persistIntent(action);
        var next = stationReturnPath();
        if (next.indexOf('?') === -1) {
            next += '?rpro_action=' + encodeURIComponent(action);
        } else {
            next += '&rpro_action=' + encodeURIComponent(action);
        }
        window.location.href = '/sso/login?next=' + encodeURIComponent(next);
    }

    function focusableElements(root) {
        return Array.prototype.slice.call(root.querySelectorAll(
            'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
        ));
    }

    function trapFocus(modal) {
        var items = focusableElements(modal);
        if (!items.length) return function() {};
        var first = items[0];
        var last = items[items.length - 1];
        function onKeyDown(e) {
            if (e.key !== 'Tab') return;
            if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        }
        modal.addEventListener('keydown', onKeyDown);
        return function() { modal.removeEventListener('keydown', onKeyDown); };
    }

    function showToast(message, type) {
        var toast = document.createElement('div');
        toast.className = 'radio-report-toast radio-report-toast-' + (type || 'info');
        toast.textContent = message;
        toast.style.cssText =
            'position:fixed;bottom:20px;left:50%;transform:translateX(-50%);' +
            'padding:10px 18px;border-radius:999px;font-size:13px;' +
            'color:#fff;background:' + (type === 'success' ? '#16a34a' : type === 'error' ? '#dc2626' : '#4b5563') + ';' +
            'box-shadow:0 4px 12px rgba(0,0,0,0.25);z-index:9999;opacity:0;transition:opacity .2s ease';
        document.body.appendChild(toast);
        requestAnimationFrame(function () { toast.style.opacity = '1'; });
        setTimeout(function () {
            toast.style.opacity = '0';
            setTimeout(function () { toast.remove(); }, 200);
        }, 2600);
    }

    function setFeedback(el, message, type) {
        if (!el) return;
        if (!message) {
            el.hidden = true;
            el.textContent = '';
            el.className = 'radio-report-feedback';
            return;
        }
        el.hidden = false;
        el.textContent = message;
        el.className = 'radio-report-feedback radio-report-feedback--' + (type || 'info');
    }

    function openModal(modal, trigger) {
        if (!modal) return;
        if (openModalRef && openModalRef.modal) {
            closeModal(openModalRef.modal);
        }
        lastTrigger = trigger || null;
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('radio-report-modal-open');
        var release = trapFocus(modal);
        var focusTarget = modal.querySelector('input, textarea, button');
        if (focusTarget) {
            setTimeout(function () { focusTarget.focus(); }, 80);
        }
        openModalRef = { modal: modal, release: release };
    }

    function closeModal(modal) {
        if (!modal) return;
        if (document.activeElement && modal.contains(document.activeElement) && lastTrigger) {
            lastTrigger.focus();
        }
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('radio-report-modal-open');
        var form = modal.querySelector('form');
        if (form) form.reset();
        modal.querySelectorAll('.radio-report-feedback').forEach(function (node) {
            setFeedback(node, '', '');
        });
        if (openModalRef && openModalRef.modal === modal && typeof openModalRef.release === 'function') {
            openModalRef.release();
        }
        if (openModalRef && openModalRef.modal === modal) {
            openModalRef = null;
        }
    }

    function isValidEmail(value) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    function submitRequest(requestType, fields, feedbackEl, submitBtn) {
        var originalLabel = submitBtn.getAttribute('data-original-label') || submitBtn.textContent;
        submitBtn.setAttribute('data-original-label', originalLabel);
        submitBtn.disabled = true;
        submitBtn.textContent = L.stationRequestSending || 'Enviando solicitação…';
        setFeedback(feedbackEl, '', '');

        var formData = new FormData();
        formData.append('request_type', requestType);
        formData.append('station_id', section.getAttribute('data-station-id') || '0');
        formData.append('radio_slug', section.getAttribute('data-radio-slug') || '');
        Object.keys(fields).forEach(function (key) {
            formData.append(key, fields[key]);
        });

        return fetch('/ajax/ajax-radio-station-request.php', {
            method: 'POST',
            body: formData,
            credentials: 'same-origin'
        })
            .then(function (resp) {
                return resp.json().catch(function () { return {}; }).then(function (data) {
                    return { ok: resp.ok, status: resp.status, data: data };
                });
            })
            .then(function (result) {
                if (result.data && result.data.needsLogin) {
                    redirectToSso(requestType);
                    return;
                }
                if (result.ok && result.data && result.data.success) {
                    setFeedback(feedbackEl, L.stationRequestSuccess || '', 'success');
                    showToast(L.stationRequestSuccess || '', 'success');
                    setTimeout(function () {
                        closeModal(requestType === 'delete_station' ? deleteModal : controlModal);
                    }, 700);
                    return;
                }
                // Anti-spam: rate-limited tem mensagem dedicada com tempo restante.
                if (result.data && result.data.error === 'rate_limited') {
                    var secs = parseInt(result.data.retryAfter, 10);
                    if (!isFinite(secs) || secs <= 0) secs = 60;
                    var template = L.stationRequestRateLimited
                        || 'Aguarde {seconds} segundos antes de enviar nova solicitação.';
                    var rlMsg = template.replace('{seconds}', String(secs));
                    setFeedback(feedbackEl, rlMsg, 'error');
                    showToast(rlMsg, 'error');
                    return;
                }
                var message = L.stationRequestError || '';
                setFeedback(feedbackEl, message, 'error');
                showToast(message, 'error');
            })
            .catch(function () {
                var message = L.stationRequestNetwork || '';
                setFeedback(feedbackEl, message, 'error');
                showToast(message, 'error');
            })
            .finally(function () {
                submitBtn.textContent = submitBtn.getAttribute('data-original-label') || L.stationRequestSubmit || '';
                submitBtn.disabled = false;
            });
    }

    function handleActionClick(action, trigger) {
        if (!isLoggedIn()) {
            redirectToSso(action);
            return;
        }
        if (action === 'delete_station') {
            openModal(deleteModal, trigger);
        } else if (action === 'request_control') {
            openModal(controlModal, trigger);
        }
    }

    if (deleteBtn) {
        deleteBtn.addEventListener('click', function () {
            handleActionClick('delete_station', deleteBtn);
        });
    }
    if (controlBtn) {
        controlBtn.addEventListener('click', function () {
            handleActionClick('request_control', controlBtn);
        });
    }

    [deleteModal, controlModal].forEach(function (modal) {
        if (!modal) return;
        var backdrop = modal.querySelector('.radio-report-modal-backdrop');
        var cancelBtn = modal.querySelector('.radio-report-btn-secondary');
        if (backdrop) {
            backdrop.addEventListener('click', function () { closeModal(modal); });
        }
        if (cancelBtn) {
            cancelBtn.addEventListener('click', function () { closeModal(modal); });
        }
    });

    document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' || !openModalRef || !openModalRef.modal) return;
        closeModal(openModalRef.modal);
    });

    var deleteForm = document.getElementById('radio-delete-request-form');
    if (deleteForm) {
        deleteForm.addEventListener('submit', function (e) {
            e.preventDefault();
            var name = (document.getElementById('radio-delete-request-name') || {}).value || '';
            var email = (document.getElementById('radio-delete-request-email') || {}).value || '';
            var whatsapp = (document.getElementById('radio-delete-request-whatsapp') || {}).value || '';
            var reason = (document.getElementById('radio-delete-request-reason') || {}).value || '';
            var feedbackEl = document.getElementById('radio-delete-request-feedback');
            var submitBtn = document.getElementById('radio-delete-request-submit-btn');
            name = name.trim();
            email = email.trim();
            whatsapp = whatsapp.trim();
            reason = reason.trim();
            if (!name || !isValidEmail(email) || !whatsapp || !reason) {
                setFeedback(feedbackEl, L.stationRequestValidation || '', 'error');
                return;
            }
            submitRequest('delete_station', {
                name: name,
                email: email,
                whatsapp: whatsapp,
                reason: reason
            }, feedbackEl, submitBtn);
        });
    }

    var controlForm = document.getElementById('radio-control-request-form');
    if (controlForm) {
        controlForm.addEventListener('submit', function (e) {
            e.preventDefault();
            var email = (document.getElementById('radio-control-request-email') || {}).value || '';
            var whatsapp = (document.getElementById('radio-control-request-whatsapp') || {}).value || '';
            var feedbackEl = document.getElementById('radio-control-request-feedback');
            var submitBtn = document.getElementById('radio-control-request-submit-btn');
            email = email.trim();
            whatsapp = whatsapp.trim();
            if (!isValidEmail(email) || !whatsapp) {
                setFeedback(feedbackEl, L.stationRequestValidation || '', 'error');
                return;
            }
            submitRequest('request_control', {
                email: email,
                whatsapp: whatsapp
            }, feedbackEl, submitBtn);
        });
    }

    var pending = readIntent();
    if (pending && isLoggedIn()) {
        clearIntent();
        if (pending === 'delete_station') {
            openModal(deleteModal, deleteBtn);
        } else if (pending === 'request_control') {
            openModal(controlModal, controlBtn);
        }
    }
})();

/* ---- radio.php inline script 3 ---- */
(function() {
    var L = window.radioPageI18n || {};
    var STREAM_HANDOFF_KEY = 'appradio_stream_handoff_v1';
    var radioPageMeta = window.__RADIOPRO_PAGE__ || { id: 0, title: '' };
    if (!radioPageMeta.id) {
        var gpMeta = document.getElementById('radio-global-player');
        if (gpMeta) {
            radioPageMeta = {
                id: parseInt(gpMeta.getAttribute('data-radio-id') || '0', 10) || 0,
                title: gpMeta.getAttribute('data-radio-title') || ''
            };
            window.__RADIOPRO_PAGE__ = radioPageMeta;
        }
    }
    var audio = document.getElementById('radio-detail-audio');
    var buttons = document.querySelectorAll('.radio-detail-stream-play');
    if (!audio || !buttons.length || audio.dataset.rpBound === '1') return;
    audio.dataset.rpBound = '1';

    // Player global (barra inferior)
    var globalPlayer        = document.getElementById('radio-global-player');
    var globalPlayButton    = globalPlayer ? globalPlayer.querySelector('.radio-global-player-play') : null;
    var globalCloseButton   = globalPlayer ? globalPlayer.querySelector('.radio-global-player-close') : null;
    var globalVolumeInput   = globalPlayer ? globalPlayer.querySelector('.radio-global-player-volume-range') : null;
    var globalVolumePercent = globalPlayer ? globalPlayer.querySelector('.radio-global-player-volume-percent') : null;
    var globalSubtitle      = globalPlayer ? globalPlayer.querySelector('.radio-global-player-subtitle') : null;
    var globalFavoriteBtn   = globalPlayer ? globalPlayer.querySelector('.radio-global-favorite-btn') : null;
    var globalProgramTrack  = globalPlayer ? globalPlayer.querySelector('.radio-global-player-program-track') : null;
    var globalProgramText   = globalPlayer ? (globalPlayer.getAttribute('data-program-text') || '') : '';
    var currentUrl = null;
    var currentBtn = null;
    var currentMetaText = '';
    var loadTimeout = null;
    var suppressErrorToast = false;
    var pendingAutoplayVerify = false;
    var autoplayVerifyTimer = null;
    var detailHls = null;

    function isHlsUrl(u) {
        return /\.m3u8(\?|$)/i.test(u || '');
    }

    function destroyDetailHls() {
        if (detailHls) {
            try { detailHls.destroy(); } catch (e) { /* ignore */ }
            detailHls = null;
        }
    }

    var _hlsLibPending = null;
    function ensureHlsLib(cb) {
        if (window.Hls) { cb(null); return; }
        if (_hlsLibPending) { _hlsLibPending.push(cb); return; }
        _hlsLibPending = [cb];
        var s = document.createElement('script');
        s.src = 'https://cdnjs.cloudflare.com/ajax/libs/hls.js/1.5.7/hls.min.js';
        s.async = true;
        function done(err) {
            var list = _hlsLibPending || [];
            _hlsLibPending = null;
            list.forEach(function (fn) { fn(err); });
        }
        s.onload = function () { done(null); };
        s.onerror = function () { done(new Error('hls_load_failed')); };
        document.head.appendChild(s);
    }

    // Liga uma playlist HLS (.m3u8) ao <audio> via hls.js. onReady dispara quando
    // o manifesto é lido; onError em falha fatal ou indisponibilidade do hls.js.
    function bindHls(url, onReady, onError) {
        destroyDetailHls();
        ensureHlsLib(function (err) {
            if (err || !window.Hls || !window.Hls.isSupported()) { onError(); return; }
            var hls = new window.Hls({ maxBufferLength: 30, liveSyncDurationCount: 3 });
            detailHls = hls;
            var settled = false;
            hls.on(window.Hls.Events.MANIFEST_PARSED, function () {
                if (!settled) { settled = true; onReady(); }
            });
            hls.on(window.Hls.Events.ERROR, function (_, data) {
                if (data && data.fatal && !settled) { settled = true; onError(); }
            });
            hls.loadSource(url);
            hls.attachMedia(audio);
        });
    }

    function saveStreamHandoff() {
        if (!currentUrl || !window.sessionStorage || !radioPageMeta) return;
        try {
            var payload = {
                v: 1,
                streamUrl: currentUrl,
                radioId: radioPageMeta.id || 0,
                radioName: radioPageMeta.title || '',
                streamTitle: currentMetaText || '',
                volume: typeof audio.volume === 'number' ? audio.volume : 1,
                wasPlaying: true,
                ts: Date.now()
            };
            sessionStorage.setItem(STREAM_HANDOFF_KEY, JSON.stringify(payload));
        } catch (e) { /* ignore quota / private mode */ }
    }

    function clearStreamHandoff() {
        if (!window.sessionStorage) return;
        try {
            sessionStorage.removeItem(STREAM_HANDOFF_KEY);
        } catch (e) { /* ignore */ }
    }

    var programMarquee = {
        started: false,
        rafId: null,
        lastTs: null,
        speed: 40 // px por segundo
    };

    function setVolumeRangeProgress(value) {
        if (!globalVolumeInput) return;
        var safe = Math.max(0, Math.min(100, value));
        globalVolumeInput.style.setProperty('--range-progress', safe + '%');
    }

    function setGlobalProgramText(text) {
        if (!globalProgramTrack) return;
        var container = globalProgramTrack.parentElement;
        if (!container) return;
        var value = (text || '').trim();
        if (value === '') {
            globalProgramTrack.textContent = '';
            container.style.display = 'none';
            return;
        }
        // Resetar posição e texto antes de iniciar o marquee
        globalProgramTrack.textContent = value;
        globalProgramTrack.style.transform = '';
        container.style.display = '';

        // Iniciar marquee baseado em JS (independente da largura)
        if (!programMarquee.started) {
            startProgramMarquee();
        }
    }

    function startProgramMarquee() {
        if (!globalProgramTrack) return;
        var container = globalProgramTrack.parentElement;
        if (!container) return;

        programMarquee.started = true;
        var currentX = container.offsetWidth; // começa logo após a borda direita
        globalProgramTrack.dataset.translateX = String(currentX);
        globalProgramTrack.style.transform = 'translateX(' + currentX + 'px)';
        programMarquee.lastTs = null;

        function step(timestamp) {
            if (!programMarquee.started) return;
            if (!programMarquee.lastTs) {
                programMarquee.lastTs = timestamp;
            }
            var delta = (timestamp - programMarquee.lastTs) / 1000; // segundos
            programMarquee.lastTs = timestamp;

            var trackWidth = globalProgramTrack.offsetWidth || 0;
            var containerWidth = container.offsetWidth || 0;
            var x = parseFloat(globalProgramTrack.dataset.translateX || String(containerWidth));

            x -= programMarquee.speed * delta;

            if (x < -trackWidth) {
                // Quando some totalmente à esquerda, volta para logo após a borda direita
                x = containerWidth;
            }

            globalProgramTrack.dataset.translateX = String(x);
            globalProgramTrack.style.transform = 'translateX(' + x + 'px)';

            programMarquee.rafId = window.requestAnimationFrame(step);
        }

        // Pausa/retoma no hover
        container.addEventListener('mouseenter', function() {
            if (programMarquee.rafId) {
                window.cancelAnimationFrame(programMarquee.rafId);
                programMarquee.rafId = null;
            }
        });
        container.addEventListener('mouseleave', function() {
            if (!programMarquee.rafId && programMarquee.started) {
                programMarquee.lastTs = null;
                programMarquee.rafId = window.requestAnimationFrame(step);
            }
        });

        programMarquee.rafId = window.requestAnimationFrame(step);
    }

    /**
     * Sincroniza o texto do marquee do player global com o bloco #radio-detail-program-current
     * (mesma lógica que updateHeroProgramFromExtra após carregar a grade via AJAX).
     */
    window.radioSyncGlobalProgramMarquee = function (text) {
        globalProgramText = text || '';
        if (globalPlayer) {
            globalPlayer.setAttribute('data-program-text', globalProgramText);
        }
        setGlobalProgramText(globalProgramText);
    };

    function getRpHeaderHeight() {
        var headerEl = document.querySelector('.rp-header');
        return headerEl ? headerEl.offsetHeight : 54;
    }

    function syncRpHeaderHeightVar() {
        document.documentElement.style.setProperty('--rp-header-height', getRpHeaderHeight() + 'px');
    }

    function syncGlobalPlayerPageOffset() {
        if (!globalPlayer) return;
        syncRpHeaderHeightVar();
        var isVisible = globalPlayer.classList.contains('is-visible');
        var isMobileLayout = window.matchMedia('(max-width: 768px)').matches;
        if (isVisible) {
            var playerHeight = globalPlayer.offsetHeight || 60;
            document.documentElement.style.setProperty('--radio-global-player-offset', playerHeight + 'px');
            if (isMobileLayout) {
                document.documentElement.style.setProperty(
                    '--radio-global-player-stacked-offset',
                    (getRpHeaderHeight() + playerHeight) + 'px'
                );
            } else {
                document.documentElement.style.removeProperty('--radio-global-player-stacked-offset');
            }
            document.body.classList.add('has-radio-global-player');
        } else {
            document.body.classList.remove('has-radio-global-player');
            document.documentElement.style.removeProperty('--radio-global-player-offset');
            document.documentElement.style.removeProperty('--radio-global-player-stacked-offset');
        }
    }

    function showGlobalPlayer(metaText) {
        if (!globalPlayer) return;
        if (metaText && globalSubtitle) {
            globalSubtitle.textContent = metaText;
        }
        setGlobalProgramText(globalProgramText);
        globalPlayer.classList.add('is-visible');
        globalPlayer.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(function() {
            syncGlobalPlayerPageOffset();
        });
    }

    function hideGlobalPlayer() {
        if (!globalPlayer) return;
        globalPlayer.classList.remove('is-visible');
        globalPlayer.setAttribute('aria-hidden', 'true');
        syncGlobalPlayerPageOffset();
    }

    function setGlobalLoading(loading) {
        if (!globalPlayer) return;
        if (loading) {
            globalPlayer.classList.add('is-loading');
        } else {
            globalPlayer.classList.remove('is-loading');
        }
        setGlobalControlsDisabled(loading);
    }

    function setGlobalControlsDisabled(disabled) {
        if (globalPlayButton) {
            globalPlayButton.disabled = !!disabled;
        }
        if (globalVolumeInput) {
            globalVolumeInput.disabled = !!disabled;
        }
        if (globalCloseButton) {
            globalCloseButton.disabled = !!disabled;
        }
        /* Não aplicar disabled no favorito: em vários navegadores o botão disabled deixa de servir de referência
           para position:absolute dos descendentes e o spinner “salta” para o .radio-global-player-inner. */
    }

    function syncGlobalPlayIcon(isPlaying) {
        if (!globalPlayButton) return;
        var icon = globalPlayButton.querySelector('i');
        if (!icon) return;
        icon.className = isPlaying ? 'fas fa-pause' : 'fas fa-play';
        globalPlayButton.setAttribute('aria-label', isPlaying ? (L.ariaPause || '') : (L.ariaPlay || ''));
    }

    function clearLoadTimeout() {
        if (loadTimeout) {
            clearTimeout(loadTimeout);
            loadTimeout = null;
        }
    }

    function setLoading(btn, loading) {
        if (loading) {
            btn.classList.add('loading');
            btn.setAttribute('aria-label', L.ariaLoading || '');
        } else {
            btn.classList.remove('loading');
            btn.setAttribute('aria-label', L.ariaPlayStream || '');
        }

        var hasAnyLoading = false;
        buttons.forEach(function(b) {
            if (b.classList.contains('loading')) {
                hasAnyLoading = true;
            }
        });
        setGlobalLoading(hasAnyLoading);
    }

    function clearAllLoading() {
        buttons.forEach(function(b) {
            b.classList.remove('loading');
            b.setAttribute('aria-label', L.ariaPlayStream || '');
        });
        setGlobalLoading(false);
        clearLoadTimeout();
    }

    function cancelPendingLoad(shouldResetCurrent, silentCancel) {
        clearAutoplayVerifyTimer();
        pendingAutoplayVerify = false;
        if (silentCancel) {
            suppressErrorToast = true;
            setTimeout(function() { suppressErrorToast = false; }, 400);
        }
        clearAllLoading();
        audio.pause();
        destroyDetailHls();
        audio.removeAttribute('src');
        audio.load();
        if (shouldResetCurrent) {
            currentUrl = null;
            currentBtn = null;
            clearStreamHandoff();
        }
    }

    function clearAutoplayVerifyTimer() {
        if (autoplayVerifyTimer) {
            clearTimeout(autoplayVerifyTimer);
            autoplayVerifyTimer = null;
        }
    }

    function resetPlayUiKeepStream() {
        clearAllLoading();
        buttons.forEach(function(b) {
            var iconWrap = b.querySelector('.radio-detail-stream-play-icon i');
            if (iconWrap) iconWrap.className = 'fas fa-play';
            b.setAttribute('aria-label', L.ariaPlayStream || '');
        });
        syncGlobalPlayIcon(false);
    }

    function handleAutoplayBlocked() {
        clearAutoplayVerifyTimer();
        pendingAutoplayVerify = false;
        suppressErrorToast = false;
        resetPlayUiKeepStream();
        if (globalPlayer && currentMetaText) {
            showGlobalPlayer(currentMetaText);
        }
        showAutoplayBlockedToast();
    }

    function scheduleAutoplayVerify() {
        if (!pendingAutoplayVerify) return;
        clearAutoplayVerifyTimer();
        autoplayVerifyTimer = setTimeout(function() {
            autoplayVerifyTimer = null;
            if (!pendingAutoplayVerify || !currentUrl) return;
            if (audio.paused && !audio.error) {
                handleAutoplayBlocked();
            }
        }, 1500);
    }

    function showAutoplayBlockedToast() {
        var msg = L.autoplayBlocked || '';
        if (!msg) return;
        var toast = document.createElement('div');
        toast.className = 'radio-stream-toast';
        toast.setAttribute('role', 'status');
        toast.textContent = msg;
        document.body.appendChild(toast);
        requestAnimationFrame(function() { toast.classList.add('show'); });
        setTimeout(function() {
            toast.classList.remove('show');
            setTimeout(function() { toast.remove(); }, 300);
        }, 4500);
    }

    function armLoadTimeout() {
        clearLoadTimeout();
        loadTimeout = setTimeout(function() {
            cancelPendingLoad(true, false);
            hideGlobalPlayer();
            setAllPlay();
            showStreamErrorToast();
        }, 12000);
    }

    function startStream(btn, url, metaText, options) {
        options = options || {};
        var waitForCanPlay = !!options.waitForCanPlay;
        suppressErrorToast = !!options.suppressErrorToast;
        pendingAutoplayVerify = !!options.isAutoplay;
        clearAutoplayVerifyTimer();
        clearStreamHandoff();
        currentUrl = url;
        currentBtn = btn;
        currentMetaText = metaText || '';
        setLoading(btn, true);
        armLoadTimeout();
        showGlobalPlayer(metaText);
        audio.removeAttribute('controls');
        destroyDetailHls();

        function onPlayFail() {
            if (pendingAutoplayVerify) {
                handleAutoplayBlocked();
                return;
            }
            if (suppressErrorToast) return;
            cancelPendingLoad(true, false);
            hideGlobalPlayer();
            setAllPlay();
            showStreamErrorToast();
        }

        function attemptPlay() {
            var p = audio.play();
            if (p && typeof p.then === 'function') {
                p.then(function() {
                    scheduleAutoplayVerify();
                }).catch(function() {
                    onPlayFail();
                });
            } else {
                scheduleAutoplayVerify();
            }
        }

        // HLS (.m3u8): navegadores sem suporte nativo usam hls.js; Safari toca via <audio>.
        if (isHlsUrl(url) && !audio.canPlayType('application/vnd.apple.mpegurl')) {
            bindHls(url, attemptPlay, onPlayFail);
            return;
        }

        audio.src = url;

        if (waitForCanPlay) {
            function onCanPlay() {
                audio.removeEventListener('canplay', onCanPlay);
                audio.removeEventListener('error', onStreamError);
                attemptPlay();
            }
            function onStreamError() {
                audio.removeEventListener('canplay', onCanPlay);
                if (suppressErrorToast) return;
                onPlayFail();
            }
            if (audio.readyState >= 2) {
                attemptPlay();
            } else {
                audio.addEventListener('canplay', onCanPlay);
                audio.addEventListener('error', onStreamError);
                audio.load();
            }
            return;
        }

        var p = audio.play();
        if (p && typeof p.then === 'function') {
            p.catch(function() {
                onPlayFail();
            });
        }
    }

    function setPlayingBtn(btn) {
        currentBtn = btn;
        clearAllLoading();
        buttons.forEach(function(b) {
            var iconWrap = b.querySelector('.radio-detail-stream-play-icon i');
            if (iconWrap) {
                iconWrap.className = b === btn ? 'fas fa-pause' : 'fas fa-play';
            }
            b.setAttribute('aria-label', b === btn ? (L.ariaPause || '') : (L.ariaPlayStream || ''));
        });
        syncGlobalPlayIcon(true);
    }
    function setAllPlay() {
        clearAllLoading();
        currentUrl = null;
        currentBtn = null;
        buttons.forEach(function(b) {
            var iconWrap = b.querySelector('.radio-detail-stream-play-icon i');
            if (iconWrap) iconWrap.className = 'fas fa-play';
            b.setAttribute('aria-label', L.ariaPlayStream || '');
        });
        syncGlobalPlayIcon(false);
    }
    function showStreamErrorToast() {
        var msg = L.streamUnavailable || '';
        var toast = document.createElement('div');
        toast.className = 'radio-stream-toast';
        toast.setAttribute('role', 'alert');
        toast.textContent = msg;
        document.body.appendChild(toast);
        requestAnimationFrame(function() { toast.classList.add('show'); });
        setTimeout(function() {
            toast.classList.remove('show');
            setTimeout(function() { toast.remove(); }, 300);
        }, 3500);
    }
    audio.addEventListener('playing', function() {
        pendingAutoplayVerify = false;
        clearAutoplayVerifyTimer();
        if (currentBtn) setPlayingBtn(currentBtn);
        saveStreamHandoff();
    });
    audio.addEventListener('canplay', function() {
        if (currentBtn && audio.currentSrc && currentUrl) {
            clearAllLoading();
        }
    });
    audio.addEventListener('pause', function() { setAllPlay(); });
    audio.addEventListener('ended', function() {
        clearStreamHandoff();
        setAllPlay();
    });
    audio.addEventListener('error', function() {
        if (suppressErrorToast) return;
        clearStreamHandoff();
        setAllPlay();
        showStreamErrorToast();
    });
    buttons.forEach(function(btn) {
        btn.addEventListener('click', function() {
            var url = this.getAttribute('data-stream-url');
            if (!url) return;

            var link = this.parentNode.querySelector('a');
            var metaText = link ? link.textContent.trim() : '';

            if (this.classList.contains('loading') && currentUrl === url) {
                cancelPendingLoad(true, true);
                hideGlobalPlayer();
                setAllPlay();
                return;
            }

            if (currentUrl === url) {
                if (audio.paused) {
                    if (!audio.currentSrc) {
                        startStream(btn, url, metaText);
                    } else {
                        var p = audio.play();
                        if (p && typeof p.then === 'function') {
                            p.catch(function() {
                                if (suppressErrorToast) return;
                                cancelPendingLoad(true, false);
                                hideGlobalPlayer();
                                setAllPlay();
                                showStreamErrorToast();
                            });
                        }
                    }
                } else {
                    clearStreamHandoff();
                    audio.pause();
                    setAllPlay();
                }
                return;
            }

            if (audio.currentSrc || !audio.paused) {
                cancelPendingLoad(false, true);
            }
            startStream(btn, url, metaText);
        });
    });

    // -----------------------------------------------------------------
    // Troca de stream via <select id="rd-stream-select">.
    // Mantém o botão Play e o link "abrir em nova aba" sincronizados,
    // e — se já estiver a tocar/carregar — faz hand-off suave para o
    // novo stream sem precisar de clicar em Play.
    // -----------------------------------------------------------------
    var streamSelect   = document.getElementById('rd-stream-select');
    var streamExternal = document.getElementById('rd-stream-external');
    if (streamSelect && buttons.length) {
        var playBtn = buttons[0];
        streamSelect.addEventListener('change', function() {
            var opt = this.options[this.selectedIndex];
            if (!opt || !playBtn) return;

            var newUrl   = opt.value;
            var rawUrl   = opt.getAttribute('data-raw-url') || newUrl;
            var newTitle = (opt.textContent || '').trim();
            var oldUrl   = playBtn.getAttribute('data-stream-url');

            playBtn.setAttribute('data-stream-url', newUrl);
            if (streamExternal) {
                streamExternal.setAttribute('href', rawUrl);
            }

            if (newTitle) currentMetaText = newTitle;

            if (oldUrl === newUrl) return;

            var isLoading = playBtn.classList.contains('loading');
            var isPlaying = !audio.paused;

            if (isLoading || isPlaying) {
                // Em curso → cancelar o anterior (silenciosamente) e iniciar o novo
                cancelPendingLoad(false, true);
                startStream(playBtn, newUrl, newTitle);
                if (globalSubtitle && newTitle) {
                    globalSubtitle.textContent = newTitle;
                }
            }
            // Pausado/parado: só atualizamos URLs;
            // o próximo clique em Play já usará o novo stream
            // (data-stream-url foi atualizado em cima).
        });
    }

    if (globalVolumeInput) {
        // volume inicial 70%
        audio.volume = 0.7;
        setVolumeRangeProgress(70);
        if (globalVolumePercent) {
            globalVolumePercent.textContent = '70%';
        }
        globalVolumeInput.addEventListener('input', function() {
            if (globalPlayer && globalPlayer.classList.contains('is-loading')) return;
            var value = parseInt(this.value, 10);
            if (isNaN(value)) return;
            var vol = Math.max(0, Math.min(100, value)) / 100;
            audio.volume = vol;
            setVolumeRangeProgress(Math.round(vol * 100));
            if (globalVolumePercent) {
                globalVolumePercent.textContent = Math.round(vol * 100) + '%';
            }
            if (currentUrl && !audio.paused) {
                saveStreamHandoff();
            }
        });
    }

    if (globalPlayButton) {
        globalPlayButton.addEventListener('click', function() {
            if (globalPlayer && globalPlayer.classList.contains('is-loading')) return;
            if (!currentUrl) {
                if (buttons[0]) {
                    buttons[0].click();
                }
                return;
            }
            if (audio.paused) {
                var p = audio.play();
                if (p && typeof p.then === 'function') {
                    p.catch(function() {
                        if (suppressErrorToast) return;
                        setAllPlay();
                        showStreamErrorToast();
                    });
                }
            } else {
                clearStreamHandoff();
                audio.pause();
                setAllPlay();
            }
        });
    }

    if (globalCloseButton) {
        globalCloseButton.addEventListener('click', function() {
            if (globalPlayer && globalPlayer.classList.contains('is-loading')) return;
            hideGlobalPlayer();
            cancelPendingLoad(true, true);
            setAllPlay();
        });
    }

    setGlobalControlsDisabled(false);

    var AUTOPLAY_INTENT_KEY = 'appradio_radio_autoplay_v1';
    var STREAM_HANDOFF_TTL_MS = 4 * 60 * 60 * 1000;
    var AUTOPLAY_INTENT_TTL_MS = 2 * 60 * 1000;

    function readJsonSession(key) {
        try {
            var raw = sessionStorage.getItem(key);
            return raw ? JSON.parse(raw) : null;
        } catch (e) {
            return null;
        }
    }

    function clearAutoplayIntent() {
        try {
            sessionStorage.removeItem(AUTOPLAY_INTENT_KEY);
        } catch (e) { /* ignore */ }
    }

    function cameFromSameOrigin() {
        try {
            if (!document.referrer) return false;
            return new URL(document.referrer).origin === window.location.origin;
        } catch (e) {
            return false;
        }
    }

    function findButtonForStreamUrl(url) {
        if (!url) return buttons[0] || null;
        for (var i = 0; i < buttons.length; i++) {
            if (buttons[i].getAttribute('data-stream-url') === url) {
                return buttons[i];
            }
        }
        return buttons[0] || null;
    }

    function getStreamMetaForButton(btn) {
        if (!btn) return '';
        var link = btn.parentNode ? btn.parentNode.querySelector('a') : null;
        return link ? link.textContent.trim() : '';
    }

    function tryAutoStartStream() {
        if (!buttons.length) return;

        var pageId = radioPageMeta.id || 0;
        var shouldStart = false;
        var targetUrl = null;
        var targetMeta = '';
        var targetBtn = buttons[0];
        var savedVolume = null;

        var handoff = readJsonSession(STREAM_HANDOFF_KEY);
        if (handoff && handoff.v === 1 && handoff.wasPlaying && handoff.streamUrl
            && (parseInt(handoff.radioId, 10) || 0) === (parseInt(pageId, 10) || 0)
            && Date.now() - (handoff.ts || 0) < STREAM_HANDOFF_TTL_MS) {
            shouldStart = true;
            targetUrl = handoff.streamUrl;
            targetMeta = handoff.streamTitle || '';
            targetBtn = findButtonForStreamUrl(targetUrl) || buttons[0];
            savedVolume = typeof handoff.volume === 'number' ? handoff.volume : null;
            clearStreamHandoff();
        }

        if (!shouldStart) {
            var intent = readJsonSession(AUTOPLAY_INTENT_KEY);
            if (intent && intent.v === 1 && String(intent.radioId) === String(pageId)
                && Date.now() - (intent.ts || 0) < AUTOPLAY_INTENT_TTL_MS) {
                shouldStart = true;
                targetUrl = buttons[0].getAttribute('data-stream-url');
                targetMeta = getStreamMetaForButton(buttons[0]);
                clearAutoplayIntent();
            }
        }

        if (!shouldStart && cameFromSameOrigin()) {
            shouldStart = true;
            targetUrl = buttons[0].getAttribute('data-stream-url');
            targetMeta = getStreamMetaForButton(buttons[0]);
        }

        if (!shouldStart || !targetUrl) return;

        if (savedVolume != null && savedVolume >= 0 && savedVolume <= 1) {
            audio.volume = savedVolume;
            var savedVolPct = Math.round(savedVolume * 100);
            setVolumeRangeProgress(savedVolPct);
            if (globalVolumeInput) {
                globalVolumeInput.value = savedVolPct;
            }
            if (globalVolumePercent) {
                globalVolumePercent.textContent = savedVolPct + '%';
            }
        }

        if (!targetMeta) {
            targetMeta = getStreamMetaForButton(targetBtn);
        }

        suppressErrorToast = true;
        startStream(targetBtn, targetUrl, targetMeta, {
            waitForCanPlay: true,
            suppressErrorToast: true,
            isAutoplay: true
        });
    }

    setTimeout(function() {
        tryAutoStartStream();
    }, 400);

    if (!window._radioGlobalPlayerOffsetBound) {
        window._radioGlobalPlayerOffsetBound = true;
        function onRadioPlayerLayoutSync() {
            syncRpHeaderHeightVar();
            syncGlobalPlayerPageOffset();
        }
        window.addEventListener('resize', onRadioPlayerLayoutSync);
        if (typeof ResizeObserver !== 'undefined') {
            var rpHeaderEl = document.querySelector('.rp-header');
            if (rpHeaderEl) {
                new ResizeObserver(onRadioPlayerLayoutSync).observe(rpHeaderEl);
            }
        }
        onRadioPlayerLayoutSync();
    }

    // --------- Favoritar rádio atual (player global) ---------
    function getCookie(name) {
        var value = '; ' + document.cookie;
        var parts = value.split('; ' + name + '=');
        var result = parts.length === 2 ? parts.pop().split(';').shift() : null;
        return result;
    }

    function getFirebaseUid() {
        // Verificar primeiro o cookie (indica sessão ativa no servidor)
        var uidFromCookie = getCookie('FIREBASE_UID');
        var uidFromStorage = window.localStorage && localStorage.getItem('FIREBASE_UID');
        
        // Se o cookie não existe mas o localStorage sim, limpar localStorage (sessão expirada)
        if (!uidFromCookie && uidFromStorage) {
            localStorage.removeItem('FIREBASE_UID');
            return null;
        }
        
        var uid = uidFromCookie || uidFromStorage;
        return uid;
    }

    // Funções para gerenciar favoritos em localStorage (para usuários não logados)
    function getLocalFavorites() {
        var json = localStorage.getItem('radiosFavoritas');
        return json ? JSON.parse(json) : [];
    }

    function setLocalFavoritesOwnerUid(uid) {
        // Mantém paridade com radio-manager.js: marca quem é o "dono" do
        // radiosFavoritas para que o sync após login não mescle favoritos
        // de contas diferentes no mesmo navegador.
        if (!uid) {
            try { localStorage.removeItem('radiosFavoritasOwnerUid'); } catch (e) {}
            return;
        }
        try { localStorage.setItem('radiosFavoritasOwnerUid', uid); } catch (e) {}
    }

    function addToLocalFavorites(radioData) {
        var favorites = getLocalFavorites();
        
        // Garantir que o ID está como número inteiro
        var radioIdNum = parseInt(radioData.id, 10);
        if (isNaN(radioIdNum)) {
            return;
        }
        
        var exists = favorites.some(function (fav) { 
            return parseInt(fav.id, 10) === radioIdNum;
        });
        
        if (!exists) {
            // Garantir que salvamos o ID como número
            radioData.id = radioIdNum;
            favorites.push(radioData);
            localStorage.setItem('radiosFavoritas', JSON.stringify(favorites));
            // Marcar dono atual ('anonymous' se não logado) para o sync pós-login
            var ownerUid = getFirebaseUid() || 'anonymous';
            setLocalFavoritesOwnerUid(ownerUid);
        }
    }

    function removeFromLocalFavorites(radioId) {
        var favorites = getLocalFavorites();
        var radioIdNum = parseInt(radioId, 10);
        
        if (isNaN(radioIdNum)) {
            return;
        }
        
        var filtered = favorites.filter(function (fav) { 
            return parseInt(fav.id, 10) !== radioIdNum;
        });
        if (filtered.length === 0) {
            try { localStorage.removeItem('radiosFavoritas'); } catch (e) {}
            setLocalFavoritesOwnerUid(null);
            return;
        }
        localStorage.setItem('radiosFavoritas', JSON.stringify(filtered));
    }

    function showFavoriteToast(message, type) {
        type = type || 'info';
        var toast = document.createElement('div');
        toast.className = 'favorite-toast favorite-toast-' + type;
        toast.textContent = message;
        toast.style.cssText =
            'position:fixed;top:20px;right:20px;padding:12px 24px;' +
            'background:' + (type === 'success' ? '#4caf50' : type === 'error' ? '#f44336' : '#ff9800') + ';' +
            'color:#fff;border-radius:4px;box-shadow:0 4px 6px rgba(0,0,0,0.1);z-index:10000;';
        document.body.appendChild(toast);
        setTimeout(function () {
            toast.style.opacity = '0';
            setTimeout(function () { toast.remove(); }, 300);
        }, 2500);
    }

    function setGlobalFavoriteVisual(isFav) {
        if (!globalFavoriteBtn) return;
        var emptyIcon = globalFavoriteBtn.querySelector('.favorite-icon-empty');
        var filledIcon = globalFavoriteBtn.querySelector('.favorite-icon-filled');
        if (emptyIcon && filledIcon) {
            emptyIcon.style.display = isFav ? 'none' : 'block';
            filledIcon.style.display = isFav ? 'block' : 'none';
        }
    }

    function setGlobalFavoriteLoading(loading) {
        if (!globalFavoriteBtn) return;
        if (loading) {
            globalFavoriteBtn.classList.add('loading');
            globalFavoriteBtn.disabled = true;
        } else {
            globalFavoriteBtn.classList.remove('loading');
            globalFavoriteBtn.disabled = false;
        }
    }

    function syncGlobalFavoriteFromServer() {
        if (!globalFavoriteBtn) {
            return;
        }
        var radioId = globalFavoriteBtn.getAttribute('data-radio-id');
        
        // Fallback: se não conseguir do atributo, tentar extrair da URL
        if (!radioId || radioId === '' || radioId === '0') {
            var urlParams = new URLSearchParams(window.location.search);
            radioId = urlParams.get('id');
        }
        
        if (!radioId) {
            return;
        }
        
        var firebaseUid = getFirebaseUid();
        
        // Se não está logado, carregar do localStorage
        if (!firebaseUid) {
            var localFavorites = getLocalFavorites();
            
            // Garantir conversão robusta de tipos
            var radioIdNum = parseInt(radioId, 10);
            if (isNaN(radioIdNum)) {
                return;
            }
            
            var isFav = localFavorites.some(function (fav) { 
                var favIdNum = parseInt(fav.id, 10);
                var matches = favIdNum === radioIdNum;
                return matches;
            });
            setGlobalFavoriteVisual(isFav);
            return;
        }

        fetch('/ajax/ajax-favorites.php?action=list', { credentials: 'same-origin' })
            .then(function (response) { 
                return response.json(); 
            })
            .then(function (data) {
                
                if (!data.success || !Array.isArray(data.favorites)) {
                    
                    // Se o backend indicar que precisa de login, podemos tentar renovar o token
                    if (data.needsLogin && typeof appradioRefreshFirebaseIdTokenCookie === 'function') {
                        try {
                            appradioRefreshFirebaseIdTokenCookie(false);
                        } catch (e) {
                            // silencioso
                        }
                    }
                    
                    // Fallback: verificar localStorage mesmo quando logado
                    var localFavorites = getLocalFavorites();
                    
                    if (localFavorites && localFavorites.length > 0) {
                        var radioIdNum = parseInt(radioId, 10);
                        var isFav = localFavorites.some(function (fav) {
                            return parseInt(fav.id, 10) === radioIdNum;
                        });
                        setGlobalFavoriteVisual(isFav);
                    }
                    return;
                }
                
                var isFav = data.favorites.some(function (fav) {
                    var id = String(fav.id || fav.radioId || '');
                    var matches = id === String(radioId);
                    return matches;
                });
                setGlobalFavoriteVisual(isFav);
            })
            .catch(function (err) {
                
                // Em caso de erro, fallback para localStorage
                var localFavorites = getLocalFavorites();
                
                if (localFavorites && localFavorites.length > 0) {
                    var radioIdNum = parseInt(radioId, 10);
                    var isFav = localFavorites.some(function (fav) {
                        return parseInt(fav.id, 10) === radioIdNum;
                    });
                    setGlobalFavoriteVisual(isFav);
                }
            });
    }

    function toggleGlobalFavorite() {
        if (!globalFavoriteBtn) return;
        if (globalFavoriteBtn.classList.contains('loading')) return;
        var firebaseUid = getFirebaseUid();
        
        var radioId = globalFavoriteBtn.getAttribute('data-radio-id');
        
        // Fallback: se não conseguir do atributo, tentar extrair da URL
        if (!radioId || radioId === '' || radioId === '0') {
            var urlParams = new URLSearchParams(window.location.search);
            radioId = urlParams.get('id');
        }
        
        if (!radioId) return;

        var emptyIcon = globalFavoriteBtn.querySelector('.favorite-icon-empty');
        var filledIcon = globalFavoriteBtn.querySelector('.favorite-icon-filled');
        var isFavorited = filledIcon && filledIcon.style.display !== 'none';

        if (isFavorited) {
            // Remover dos favoritos
            if (firebaseUid) {
                // Usuário logado: sincronizar com servidor
                var formData = new FormData();
                formData.append('action', 'remove');
                formData.append('radioId', radioId);

                setGlobalFavoriteLoading(true);
                fetch('/ajax/ajax-favorites.php', {
                    method: 'POST',
                    body: formData,
                    credentials: 'same-origin'
                })
                    .then(function (response) { return response.json(); })
                    .then(function (data) {
                        if (data.success) {
                            setGlobalFavoriteVisual(false);
                            showFavoriteToast(L.favoriteRemoved || '', 'success');
                        } else if (data.needsLogin) {
                            // Manter no localStorage
                            removeFromLocalFavorites(radioId);
                            setGlobalFavoriteVisual(false);
                            showFavoriteToast(L.favoriteRemoved || '', 'success');
                        } else {
                            showFavoriteToast(data.error || L.favoriteErrorRemove || '', 'error');
                        }
                    })
                    .catch(function (err) {
                        showFavoriteToast(L.favoriteErrorRemoveNetwork || '', 'error');
                    })
                    .finally(function () {
                        setGlobalFavoriteLoading(false);
                    });
            } else {
                // Não está logado: usar localStorage
                removeFromLocalFavorites(radioId);
                setGlobalFavoriteVisual(false);
                showFavoriteToast(L.favoriteRemoved || '', 'success');
            }
        } else {
            // Adicionar aos favoritos
            var titleEl = globalPlayer.querySelector('.radio-global-player-title');
            var subtitleEl = globalPlayer.querySelector('.radio-global-player-subtitle');
            var logoEl = globalPlayer.querySelector('.radio-global-player-logo img');
            var firstStreamBtn = buttons[0];
            var streamUrl = firstStreamBtn ? firstStreamBtn.getAttribute('data-stream-url') : '';
            var radioSource = {
                id: parseInt(radioId, 10),
                title: titleEl ? titleEl.textContent.trim() : '',
                url_logo: logoEl ? logoEl.getAttribute('src') : '',
                localizacao: subtitleEl ? subtitleEl.textContent.trim() : '',
                segmento: subtitleEl ? subtitleEl.textContent.trim() : '',
                streams: streamUrl ? [{ url: streamUrl }] : []
            };
            var radioData = (window.RadiosProFavorites && typeof window.RadiosProFavorites.buildPayload === 'function')
                ? (window.RadiosProFavorites.buildPayload(radioSource) || radioSource)
                : radioSource;

            if (firebaseUid) {
                // Usuário logado: sincronizar com servidor
                var formData = new FormData();
                formData.append('action', 'add');
                formData.append('radioId', radioId);
                formData.append('radioData', JSON.stringify(radioData));

                setGlobalFavoriteLoading(true);
                fetch('/ajax/ajax-favorites.php', {
                    method: 'POST',
                    body: formData,
                    credentials: 'same-origin'
                })
                    .then(function (response) { return response.json(); })
                    .then(function (data) {
                        if (data.success) {
                            setGlobalFavoriteVisual(true);
                            showFavoriteToast(L.favoriteAdded || '', 'success');
                        } else if (data.needsLogin) {
                            // Manter no localStorage
                            addToLocalFavorites(radioData);
                            setGlobalFavoriteVisual(true);
                            showFavoriteToast(L.favoriteAdded || '', 'success');
                        } else {
                            showFavoriteToast(data.error || L.favoriteErrorAdd || '', 'error');
                        }
                    })
                    .catch(function (err) {
                        showFavoriteToast(L.favoriteErrorAddNetwork || '', 'error');
                    })
                    .finally(function () {
                        setGlobalFavoriteLoading(false);
                    });
            } else {
                // Não está logado: usar localStorage
                addToLocalFavorites(radioData);
                setGlobalFavoriteVisual(true);
                
                // Mostrar toast de sincronização apenas uma vez
                var syncToastShown = localStorage.getItem('syncToastShown');
                if (!syncToastShown) {
                    showFavoriteToast(L.favoriteSyncLogin || '', 'success');
                    localStorage.setItem('syncToastShown', 'true');
                } else {
                    showFavoriteToast(L.favoriteAdded || '', 'success');
                }
            }
        }
    }

    if (globalFavoriteBtn) {
        globalFavoriteBtn.addEventListener('click', function (e) {
            e.preventDefault();
            if (globalPlayer && globalPlayer.classList.contains('is-loading')) return;
            toggleGlobalFavorite();
        });
        // ao carregar a página, alinhar estado visual com o servidor
        syncGlobalFavoriteFromServer();
    } else {
        // Retry após 500ms se o botão não foi encontrado
        setTimeout(function() {
            var retryGlobalFavoriteBtn = globalPlayer ? globalPlayer.querySelector('.radio-global-favorite-btn') : null;
            if (retryGlobalFavoriteBtn) {
                retryGlobalFavoriteBtn.addEventListener('click', function (e) {
                    e.preventDefault();
                    if (globalPlayer && globalPlayer.classList.contains('is-loading')) return;
                    toggleGlobalFavorite();
                });
                globalFavoriteBtn = retryGlobalFavoriteBtn;
                syncGlobalFavoriteFromServer();
            }
        }, 500);
    }
})();

/* ---- radio.php inline script 4 ---- */
(function() {
    var L = window.radioPageI18n || {};
    function escapeHtml(value) {
        return String(value == null ? '' : value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    function buildMarqueeLineFromProgram(nextTitle, nextDetail) {
        var prefix = (L.programNow || '').trim();
        var t = (nextTitle || '').trim();
        var d = (nextDetail || '').trim();
        if (!t && !d) {
            return '';
        }
        var parts = [];
        if (t) {
            parts.push(t);
        }
        if (d) {
            parts.push(d);
        }
        return (prefix ? prefix + ': ' : '') + parts.join(' • ');
    }

    function updateHeroProgramFromExtra(root, options) {
        var programBlock = document.getElementById('radio-detail-program-current');
        if (!programBlock) {
            return;
        }

        var titleEl = programBlock.querySelector('[data-program-title]');
        var detailEl = programBlock.querySelector('[data-program-detail]');
        if (!titleEl || !detailEl) {
            return;
        }

        var payload = root ? root.querySelector('#radio-current-program-payload') : null;
        var fallbackTitle = programBlock.getAttribute('data-fallback-title') || '';
        var fallbackDetail = programBlock.getAttribute('data-fallback-detail') || '';
        var placeholderTitle = programBlock.getAttribute('data-placeholder-title') || '';
        var placeholderDetail = programBlock.getAttribute('data-placeholder-detail') || '';
        // "no-current" = grade carregada mas nenhum slot ativo para o horario atual.
        // Diferente do placeholder (que e "Carregando..."): aqui informamos "Livre".
        var noCurrentTitle = programBlock.getAttribute('data-no-current-title') || placeholderTitle;
        var noCurrentDetail = programBlock.getAttribute('data-no-current-detail') || placeholderDetail;
        var nextTitle = placeholderTitle;
        var nextDetail = placeholderDetail;

        if (payload && payload.getAttribute('data-has-current-program') === '1') {
            nextTitle = payload.getAttribute('data-title') || '';
            nextDetail = payload.getAttribute('data-detail') || '';
        } else if (root && payload && payload.getAttribute('data-schedule-loaded') === '1') {
            // Grade carregada mas nenhum slot cobre o horário atual → "Livre".
            nextTitle = noCurrentTitle;
            nextDetail = noCurrentDetail;
        } else if (fallbackTitle || fallbackDetail) {
            nextTitle = fallbackTitle;
            nextDetail = fallbackDetail;
        } else if ((options && options.hideIfEmpty) || !payload) {
            programBlock.style.display = 'none';
            if (typeof window.radioSyncGlobalProgramMarquee === 'function') {
                window.radioSyncGlobalProgramMarquee('');
            }
            return;
        } else {
            programBlock.style.display = 'none';
            if (typeof window.radioSyncGlobalProgramMarquee === 'function') {
                window.radioSyncGlobalProgramMarquee('');
            }
            return;
        }

        programBlock.style.display = '';
        titleEl.innerHTML = escapeHtml(nextTitle);
        detailEl.innerHTML = nextDetail ? escapeHtml(nextDetail) : '';
        detailEl.style.display = nextDetail ? '' : 'none';

        if (typeof window.radioSyncGlobalProgramMarquee === 'function') {
            window.radioSyncGlobalProgramMarquee(buildMarqueeLineFromProgram(nextTitle, nextDetail));
        }
    }

    function initNewsLazy(root) {
        var btn = root.querySelector('#radio-news-load-btn');
        var container = root.querySelector('#radio-news-lazy-container');
        if (!btn || !container || btn.dataset.bound === 'true') {
            return;
        }

        btn.dataset.bound = 'true';
        var isLoading = false;

        function setLoading(state) {
            isLoading = state;
            if (state) {
                btn.classList.add('is-loading');
                btn.disabled = true;
            } else {
                btn.classList.remove('is-loading');
                btn.disabled = false;
            }
        }

        btn.addEventListener('click', function() {
            if (isLoading) return;
            var radioId = btn.getAttribute('data-radio-id');
            if (!radioId) return;

            setLoading(true);

            fetch('/radio/' + encodeURIComponent(radioId) + '?ajax=news')
                .then(function(response) { return response.json(); })
                .then(function(data) {
                    if (!data.success || !Array.isArray(data.articles) || data.articles.length === 0) {
                        container.innerHTML = '<p class="radio-detail-news-empty">' + escapeHtml(L.newsEmpty || '') + '</p>';
                        return;
                    }

                    var html = '';
                    html += '<div class="radio-detail-news-list">';
                    data.articles.forEach(function(article, index) {
                        var isHidden = index >= 4;
                        html += '<article class="radio-detail-news-item' + (isHidden ? ' radio-detail-news-item-hidden' : '') + '">';
                        html += '<a href="' + (article.url || '#') + '" target="_blank" rel="noopener noreferrer" class="radio-detail-news-link">';
                        if (article.image) {
                            html += '<div class="radio-detail-news-image-wrap">';
                            html += '<img src="' + article.image + '" alt="' + (article.title || '') + '">';
                            html += '</div>';
                        }
                        html += '<h3 class="radio-detail-news-title">' + (article.title || '') + '</h3>';
                        if (article.description) {
                            html += '<p class="radio-detail-news-description">' + article.description + '</p>';
                        }
                        if (Array.isArray(article.summary) && article.summary.length) {
                            html += '<ul class="radio-detail-news-summary">';
                            article.summary.forEach(function(p) {
                                html += '<li>' + p + '</li>';
                            });
                            html += '</ul>';
                        }
                        html += '<div class="radio-detail-news-meta">';
                        if (article.published) {
                            html += '<span class="radio-detail-news-date">' + escapeHtml(L.newsPublished || '') + ' ' + escapeHtml(article.published) + '</span>';
                        }
                        if (article.updated && article.updated !== article.published) {
                            html += '<span class="radio-detail-news-date">' + escapeHtml(L.newsUpdated || '') + ' ' + escapeHtml(article.updated) + '</span>';
                        }
                        html += '</div>';
                        html += '</a>';
                        html += '</article>';
                    });
                    html += '</div>';

                    if (data.articles.length > 4) {
                        html += '<div class="radio-detail-news-more-wrapper">';
                        html += '<button type="button" class="radio-detail-news-more-btn">' + escapeHtml(L.newsLoadMore || '') + '</button>';
                        html += '</div>';
                    }

                    container.innerHTML = html;

                    var moreBtn = container.querySelector('.radio-detail-news-more-btn');
                    if (moreBtn) {
                        moreBtn.addEventListener('click', function() {
                            container.querySelectorAll('.radio-detail-news-item-hidden').forEach(function(el) {
                                el.classList.remove('radio-detail-news-item-hidden');
                            });
                            moreBtn.remove();
                        });
                    }
                })
                .catch(function(err) {
                    console.error('Erro ao carregar noticias:', err);
                    container.innerHTML = '<p class="radio-detail-news-empty">' + escapeHtml(L.newsErrorLoad || '') + '</p>';
                })
                .finally(function() {
                    setLoading(false);
                });
        });
    }

    function initScheduleControls(root) {
        var scheduleBtn = root.querySelector('#radio-schedule-toggle-btn');
        var scheduleContainer = root.querySelector('#radio-schedule-container');
        var scheduleSubtitle = root.querySelector('#radio-schedule-subtitle');
        if (!scheduleBtn || !scheduleContainer || scheduleBtn.dataset.bound === 'true') {
            return;
        }

        scheduleBtn.dataset.bound = 'true';
        var labelEl = scheduleBtn.querySelector('.radio-schedule-toggle-label');

        function setScheduleExpanded(expanded) {
            scheduleBtn.setAttribute('data-expanded', expanded ? 'true' : 'false');
            if (expanded) {
                scheduleContainer.style.display = '';
                scheduleBtn.classList.remove('collapsed');
                if (labelEl) labelEl.textContent = L.scheduleHide || '';
                if (scheduleSubtitle) scheduleSubtitle.textContent = '';
            } else {
                scheduleContainer.style.display = 'none';
                scheduleBtn.classList.add('collapsed');
                if (labelEl) labelEl.textContent = L.scheduleShow || '';
                if (scheduleSubtitle) {
                    scheduleSubtitle.textContent = L.scheduleHintCollapsed || '';
                }
            }
        }

        scheduleBtn.addEventListener('click', function() {
            var expanded = scheduleBtn.getAttribute('data-expanded') === 'true';
            setScheduleExpanded(!expanded);
        });

        setScheduleExpanded(false);
    }

    function initScheduleTabs(root) {
        var tabs = root.querySelectorAll('.radio-detail-schedule-tab');
        if (!tabs.length) {
            return;
        }

        var panels = root.querySelectorAll('.radio-detail-schedule-panel');
        tabs.forEach(function(tab) {
            if (tab.dataset.bound === 'true') {
                return;
            }
            tab.dataset.bound = 'true';
            tab.addEventListener('click', function() {
                var panelId = this.getAttribute('data-panel');
                tabs.forEach(function(t) {
                    t.setAttribute('aria-selected', 'false');
                    t.classList.remove('active');
                });
                panels.forEach(function(p) {
                    p.hidden = true;
                });
                this.setAttribute('aria-selected', 'true');
                this.classList.add('active');
                var panel = root.querySelector('#' + panelId);
                if (panel) {
                    panel.hidden = false;
                }
            });
        });
    }

    function executeScriptsSequentially(container) {
        var scripts = Array.prototype.slice.call(container.querySelectorAll('script'));
        return scripts.reduce(function(chain, oldScript) {
            return chain.then(function() {
                return new Promise(function(resolve) {
                    var newScript = document.createElement('script');

                    Array.prototype.slice.call(oldScript.attributes).forEach(function(attr) {
                        newScript.setAttribute(attr.name, attr.value);
                    });

                    if (oldScript.src) {
                        newScript.onload = resolve;
                        newScript.onerror = resolve;
                        newScript.src = oldScript.src;
                        document.body.appendChild(newScript);
                    } else {
                        newScript.text = oldScript.textContent || '';
                        document.body.appendChild(newScript);
                        resolve();
                    }
                });
            });
        }, Promise.resolve());
    }

    function waitForExtraSectionLayout() {
        return new Promise(function(resolve) {
            var deadline = Date.now() + 5000;
            function tick() {
                if (window.tailwind || Date.now() >= deadline) {
                    requestAnimationFrame(function() {
                        requestAnimationFrame(resolve);
                    });
                    return;
                }
                requestAnimationFrame(tick);
            }
            tick();
        });
    }

    function loadExtraSection() {
        var extra = document.getElementById('radio-detail-extra');
        var content = document.getElementById('radio-detail-extra-content');
        if (!extra || !content) {
            return;
        }

        var radioId = extra.getAttribute('data-radio-id');
        if (!radioId) {
            extra.classList.remove('is-loading');
            return;
        }
        if (extra.dataset.rpLoadedId === String(radioId)) {
            return;
        }
        extra.dataset.rpLoadedId = String(radioId);

        var appLang = extra.getAttribute('data-app-lang') || 'pt';
        fetch('/radio/' + encodeURIComponent(radioId) + '?ajax=extra&lang=' + encodeURIComponent(appLang))
            .then(function(response) { return response.json(); })
            .then(function(data) {
                if (!data.success || typeof data.html !== 'string') {
                    throw new Error('invalid_extra_payload');
                }

                content.innerHTML = data.html;
                return executeScriptsSequentially(content).then(function() {
                    updateHeroProgramFromExtra(content);
                    initScheduleTabs(content);
                    initScheduleControls(content);
                    initNewsLazy(content);
                    return waitForExtraSectionLayout();
                });
            })
            .catch(function(err) {
                console.error('Erro ao carregar conteudo adicional da radio:', err);
                updateHeroProgramFromExtra(null, { hideIfEmpty: true });
                content.innerHTML = '<div class="radio-detail-block radio-detail-status-block"><p class="radio-detail-status"><small>' + escapeHtml(L.extraLoadFailed || '') + '</small></p></div>';
            })
            .finally(function() {
                extra.classList.remove('is-loading');
            });
    }

    loadExtraSection();
})();

/* ---- radio.php inline script 5 ---- */
(function () {
    var container = document.getElementById('radio-banners-carousel');
    if (!container) return;
    var track = document.getElementById('rd-banners-track');
    var dots  = document.getElementById('rd-banners-dots');
    var prev  = document.getElementById('rd-banners-prev');
    var next  = document.getElementById('rd-banners-next');
    if (!track || !dots) return;

    var radioId = parseInt(container.getAttribute('data-radio-id'), 10) || 0;
    if (!radioId || container.dataset.rpLoadedId === String(radioId)) return;
    container.dataset.rpLoadedId = String(radioId);
    var endpoint = APPRADIO_ORIGIN + '/ajax/radio-banners-list.php?radioId=' + radioId;

    function escapeHtml(s) {
        return String(s == null ? '' : s)
            .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    var slides = [];
    var index = 0;
    var timer = null;
    var INTERVAL_MS = 10000;

    function goTo(i, manual) {
        if (!slides.length) return;
        index = ((i % slides.length) + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + (index * 100) + '%)';
        Array.prototype.forEach.call(dots.children, function (dot, idx) {
            dot.classList.toggle('is-active', idx === index);
            dot.setAttribute('aria-selected', idx === index ? 'true' : 'false');
        });
        if (manual) restartTimer();
    }

    function nextSlide() { goTo(index + 1); }
    function prevSlide() { goTo(index - 1); }

    function stopTimer() {
        if (timer) { clearInterval(timer); timer = null; }
    }
    function startTimer() {
        // Idempotente: garante que NUNCA exista mais de um timer ativo.
        // Sem este stopTimer aqui, eventos como mouseleave + clique de seta +
        // visibilitychange empilhavam intervals e a rotacao acelerava.
        stopTimer();
        if (slides.length <= 1) return;
        timer = setInterval(nextSlide, INTERVAL_MS);
    }
    function restartTimer() {
        startTimer();
    }

    fetch(endpoint, { mode: 'cors', credentials: 'omit' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
            if (!j || !j.success || !j.banners || j.banners.length === 0) return;
            slides = j.banners;

            // Render slides
            track.innerHTML = slides.map(function (b) {
                var title = escapeHtml(b.title || '');
                var url   = escapeHtml(b.url   || '');
                var cta   = escapeHtml(b.ctaUrl || '');
                var titleBlock = title ? '<div class="rd-banner-title">' + title + '</div>' : '';
                var inner = '<img src="' + url + '" alt="' + title + '" loading="lazy">' + titleBlock;
                if (cta) {
                    return '<a class="rd-banner-slide" href="' + cta + '" target="_blank" rel="noopener" aria-label="' + (title || 'Banner') + '">' + inner + '</a>';
                }
                return '<div class="rd-banner-slide rd-banner-slide--no-cta">' + inner + '</div>';
            }).join('');

            // Render dots
            dots.innerHTML = slides.map(function (_, i) {
                return '<button type="button" class="rd-banner-dot' + (i === 0 ? ' is-active' : '') + '" role="tab" aria-selected="' + (i === 0) + '" aria-label="Banner ' + (i + 1) + '" data-idx="' + i + '"></button>';
            }).join('');

            // Wire dots
            Array.prototype.forEach.call(dots.children, function (dot) {
                dot.addEventListener('click', function () {
                    goTo(parseInt(dot.getAttribute('data-idx'), 10), true);
                });
            });

            // Wire arrows
            if (prev) prev.addEventListener('click', function () { goTo(index - 1, true); });
            if (next) next.addEventListener('click', function () { goTo(index + 1, true); });

            // Esconde controles se só 1 banner
            if (slides.length <= 1) {
                if (prev) prev.style.display = 'none';
                if (next) next.style.display = 'none';
                dots.style.display = 'none';
            }

            // Pausa no hover
            container.addEventListener('mouseenter', stopTimer);
            container.addEventListener('mouseleave', startTimer);
            // Pausa quando aba não está visível
            document.addEventListener('visibilitychange', function () {
                if (document.hidden) stopTimer(); else startTimer();
            });

            container.removeAttribute('hidden');
            goTo(0);
            startTimer();
        })
        .catch(function () { /* silencio: banners ausentes nao quebram a pagina */ });
})();

/* ---- radio.php inline script 6 ---- */
(function () {
    var container = document.getElementById('rd-promo-audios');
    if (!container) return;
    var listEl = document.getElementById('rd-promo-audios-list');
    var radioId = parseInt(container.getAttribute('data-radio-id'), 10) || 0;
    if (!radioId || !listEl || container.dataset.rpLoadedId === String(radioId)) return;
    container.dataset.rpLoadedId = String(radioId);

    var endpoint = APPRADIO_ORIGIN + '/ajax/radio-audios-list.php?radioId=' + radioId;

    function escapeHtml(s) {
        return String(s == null ? '' : s)
            .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    function fmtTime(s) {
        if (!isFinite(s) || s < 0) s = 0;
        s = Math.floor(s);
        var m = Math.floor(s / 60);
        var sec = s % 60;
        return m + ':' + (sec < 10 ? '0' : '') + sec;
    }

    function wireItem(li) {
        var audio    = li.querySelector('.rd-promo-audio-el');
        var btn      = li.querySelector('.rd-promo-audio-play');
        var icon     = btn ? btn.querySelector('i') : null;
        var progress = li.querySelector('.rd-promo-audio-progress');
        var fill     = li.querySelector('.rd-promo-audio-progress-fill');
        var timeEl   = li.querySelector('.rd-promo-audio-time');
        if (!audio || !btn || !progress || !fill || !timeEl) return;

        function updateTime() {
            var cur = audio.currentTime || 0;
            var dur = isFinite(audio.duration) ? audio.duration : 0;
            timeEl.textContent = dur > 0 ? (fmtTime(cur) + ' / ' + fmtTime(dur)) : fmtTime(cur);
            var pct = dur > 0 ? (cur / dur * 100) : 0;
            fill.style.width = pct + '%';
            progress.setAttribute('aria-valuenow', String(Math.round(pct)));
        }
        function setPlaying(playing) {
            btn.classList.toggle('is-playing', playing);
            if (icon) icon.className = playing ? 'fas fa-pause' : 'fas fa-play';
            btn.setAttribute('aria-label', playing ? 'Pausar' : 'Tocar');
        }

        btn.addEventListener('click', function () {
            Array.prototype.forEach.call(listEl.querySelectorAll('.rd-promo-audio-el'), function (other) {
                if (other !== audio) other.pause();
            });
            if (audio.paused) audio.play(); else audio.pause();
        });
        progress.addEventListener('click', function (e) {
            var rect = progress.getBoundingClientRect();
            var pct = (e.clientX - rect.left) / rect.width;
            pct = Math.max(0, Math.min(1, pct));
            if (isFinite(audio.duration) && audio.duration > 0) {
                audio.currentTime = audio.duration * pct;
            }
        });
        audio.addEventListener('play',           function () { setPlaying(true); });
        audio.addEventListener('pause',          function () { setPlaying(false); });
        audio.addEventListener('ended',          function () { setPlaying(false); audio.currentTime = 0; updateTime(); });
        audio.addEventListener('timeupdate',     updateTime);
        audio.addEventListener('loadedmetadata', updateTime);
    }

    fetch(endpoint, { mode: 'cors', credentials: 'omit' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
            if (!j || !j.success || !j.audios || !j.audios.length) return;
            listEl.innerHTML = j.audios.map(function (a) {
                var url   = escapeHtml(a.url || '');
                var title = escapeHtml(a.title || '');
                var titleHtml = title
                    ? '<div class="rd-promo-audio-title">' + title + '</div>'
                    : '';
                return '<li class="rd-promo-audio-item">' +
                       titleHtml +
                       '<audio class="rd-promo-audio-el" preload="metadata" src="' + url + '"></audio>' +
                       '<div class="rd-promo-audio-controls">' +
                         '<button type="button" class="rd-promo-audio-play" aria-label="Tocar">' +
                           '<i class="fas fa-play" aria-hidden="true"></i>' +
                         '</button>' +
                         '<div class="rd-promo-audio-progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">' +
                           '<div class="rd-promo-audio-progress-fill"></div>' +
                         '</div>' +
                         '<span class="rd-promo-audio-time">0:00</span>' +
                       '</div>' +
                       '</li>';
            }).join('');
            Array.prototype.forEach.call(listEl.querySelectorAll('.rd-promo-audio-item'), wireItem);
            container.removeAttribute('hidden');
        })
        .catch(function () { /* silencio: audios ausentes nao quebram a pagina */ });
})();

/* ---- radio.php inline script 7 ---- */
(function () {
    var openBtn  = document.getElementById('rd-open-contact-form');
    var modal    = document.getElementById('rd-contact-modal');
    var closeBtn = document.getElementById('rd-contact-modal-close');
    if (!openBtn || !modal || openBtn.dataset.rpBound === '1') return;
    openBtn.dataset.rpBound = '1';

    function open() {
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        var first = modal.querySelector('input[name="name"]');
        if (first) setTimeout(function () { first.focus(); }, 30);
    }
    function close() {
        modal.hidden = true;
        document.body.style.overflow = '';
    }

    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) close();
    });
})();

/* ---- radio.php inline script 8 ---- */
(function () {
    var form = document.getElementById('radio-contact-form');
    if (!form || form.dataset.rpBound === '1') return;
    form.dataset.rpBound = '1';
    var fb = document.getElementById('radio-contact-feedback');
    var endpoint = APPRADIO_ORIGIN + '/ajax/radio-contact-message.php';

    form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var btn = form.querySelector('button[type=submit]');
        if (btn) btn.disabled = true;
        if (fb) {
            fb.textContent = 'Enviando…';
            fb.className = 'radio-contact-feedback is-pending';
        }

        var fd = new FormData(form);
        fetch(endpoint, {
            method: 'POST',
            body: fd,
            credentials: 'include',
            mode: 'cors'
        })
        .then(function (r) {
            return r.json().catch(function () { return null; }).then(function (j) {
                return { ok: r.ok, status: r.status, j: j };
            });
        })
        .then(function (res) {
            if (btn) btn.disabled = false;
            if (res.j && res.j.success) {
                if (fb) {
                    fb.textContent = 'Mensagem enviada! A rádio entrará em contato em breve.';
                    fb.className = 'radio-contact-feedback is-success';
                }
                form.reset();
                return;
            }
            var msg = 'Erro ao enviar.';
            if (res.j && res.j.error) {
                if      (res.j.error === 'rate_limited')      msg = 'Aguarde alguns minutos antes de enviar outra mensagem.';
                else if (res.j.error === 'validation_failed') msg = 'Verifique os campos preenchidos.';
                else if (res.j.error === 'radio_not_found')   msg = 'Rádio não encontrada.';
                else                                          msg = 'Erro: ' + res.j.error;
            }
            if (fb) {
                fb.textContent = msg;
                fb.className = 'radio-contact-feedback is-error';
            }
        })
        .catch(function () {
            if (btn) btn.disabled = false;
            if (fb) {
                fb.textContent = 'Falha de rede. Tente novamente.';
                fb.className = 'radio-contact-feedback is-error';
            }
        });
    });
})();
}
